import { getConsent } from './consent'

export type AnalyticsEventName =
  | 'whatsapp_click'
  | 'phone_click'
  | 'email_click'
  | 'lead_form_submit'
  | 'schedule_tour_click'
  | 'official_listing_click'
  | 'zillow_listing_click'
  | 'gallery_open'
  | 'map_open'
  | 'language_switch'

/**
 * Non-identifying event parameters only.
 * Names, phone numbers, email addresses, dates and message contents are NEVER
 * passed here and are never forwarded to Meta Pixel or Google Analytics.
 */
export type AnalyticsParams = Record<string, string | number | boolean>

const PII_KEYS = [
  'name',
  'fullname',
  'email',
  'phone',
  'telephone',
  'message',
  'address',
  'date',
]

function stripPii(params: AnalyticsParams): AnalyticsParams {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([key]) => !PII_KEYS.some((piiKey) => key.toLowerCase().includes(piiKey)),
    ),
  )
}

export function trackEvent(name: AnalyticsEventName, params: AnalyticsParams = {}): void {
  const payload = { event: name, ...stripPii(params) }

  // Meta Pixel + Google Analytics placeholders. Advertising trackers are only
  // loaded and fed after consent; measurement IDs live in server-side config,
  // never in this client bundle.
  if (getConsent() !== 'granted') {
    return
  }

  const globalWindow = window as unknown as {
    dataLayer?: unknown[]
    fbq?: (...args: unknown[]) => void
  }

  if (Array.isArray(globalWindow.dataLayer)) {
    globalWindow.dataLayer.push(payload)
  }
  if (typeof globalWindow.fbq === 'function') {
    globalWindow.fbq('trackCustom', name, stripPii(params))
  }
}
